import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-show-all.tsx
/**
* icon.24.show-all
*
* Keywords: menu, vertical, dots, three, options, kebab, more
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTIgMTZhMSAxIDAgMSAxIDAgMiAxIDEgMCAwIDEgMC0ybTAtNWExIDEgMCAxIDEgMCAyIDEgMSAwIDAgMSAwLTJtMS00YTEgMSAwIDEgMC0yIDAgMSAxIDAgMCAwIDIgMCIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-723
*/
const Icon24ShowAll = memo(function Icon24ShowAll(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M12 16a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m1-4a1 1 0 1 0-2 0 1 1 0 0 0 2 0",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24ShowAll };

//# sourceMappingURL=icon-24-show-all.js.map